module.exports = __webpack_public_path__ + "img/harvest1.fec2c9b1.png";